module.exports = __webpack_public_path__ + "img/Ico_download.a178857b.svg";